<script>
import appConfig from "@/app.config";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Detail Histori Asesmen",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  data() {
    return {
      idJadwal: this.$route.params.id,
      tokenJadwal: this.$route.query.token_jadwal,
      // ditampilkan langsung dari data baris yang diklik di halaman list,
      // supaya info dasar tetap tampil walau fetch kompetensi di bawah gagal/pending
      headerInfo: {
        kode_tes: this.$route.query.kode_tes,
        keterangan: this.$route.query.keterangan,
        tanggal_mulai: this.$route.query.tanggal_mulai,
        tanggal_selesai: this.$route.query.tanggal_selesai,
      },

      kompetensiState: {
        loading: true,
        list: [],
      },
    };
  },

  mounted() {
    this.getListKompetensi();
  },

  methods: {
    // list_kompetensi diambil dari endpoint yang sama dengan CardListAssessmen di
    // dashboard_assesmen_hc.vue (peserta/jadwal-peserta). nip & token_jadwal wajib
    // dikirim, tanpa keduanya BE mencoba memuat seluruh data dan out of memory
    getListKompetensi() {
      let self = this;
      self.kompetensiState.loading = true;
      axios({
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "peserta/jadwal-peserta",
        params: {
          nip: localStorage.session_username,
          token_jadwal: self.tokenJadwal,
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      })
        .then((response) => {
          let response_data = response.data;
          if (response_data.meta.code == 200) {
            let jadwal = (response_data.data || []).find(
              (item) => item.idjadwal == self.idJadwal
            );
            self.kompetensiState.list = jadwal?.list_kompetensi || [];
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data.meta.message,
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        })
        .finally(() => {
          self.kompetensiState.loading = false;
        });
    },
    backButton() {
      this.$router.push({
        name: "dashboard-pegawai",
        query: { tab: "history-asesmen" },
      });
    },
  },
};
</script>

<template>
  <div class="mym-navbar">
    <div class="mym-navbar-inner">
      <div class="mym-navbar-brand">
        <div class="mym-navbar-logo">
          <img src="/logo_pln.png" alt="Logo PLN" style="height: 40px; object-fit: contain;" />
        </div>

        <div class="mym-navbar-text">
          <div class="mym-navbar-title">Dashboard Pegawai</div>
          <div class="mym-navbar-subtitle">Unit Pelaksana Sertifikasi</div>
        </div>
      </div>

      <div class="mym-navbar-action">
        <a href="javascript:void(0)" @click="backButton()">
          <i class="fas fa-arrow-left me-1"></i>
          Kembali
        </a>
      </div>
    </div>
  </div>

  <div class="mym-main-area">
    <div class="mym-content-panel mb-4">
      <div class="mym-section-body">
        <div class="row">
          <div class="col-12 d-flex justify-content-between align-items-center mb-3">
            <h4 class="fw-bold mb-0">Detail Histori Asesmen</h4>
            <b-button
              size="sm"
              variant="danger"
              class="fw-bold"
              @click="backButton"
            >
              <i class="fa fa-arrow-left me-1"></i>
              Kembali
            </b-button>
          </div>

          <div class="col-12">
            <hr class="mt-0" />
          </div>

          <div class="col-12">
            <table border="0" class="mb-2">
              <tr class="mb-2">
                <td><b>Kode Tes</b></td>
                <td>&nbsp;:&nbsp;</td>
                <td>{{ headerInfo.kode_tes || "-" }}</td>
              </tr>
              <tr class="mb-2">
                <td><b>Keterangan</b></td>
                <td>&nbsp;:&nbsp;</td>
                <td>{{ headerInfo.keterangan || "-" }}</td>
              </tr>
              <tr class="mb-2">
                <td><b>Tanggal Mulai</b></td>
                <td>&nbsp;:&nbsp;</td>
                <td>{{ headerInfo.tanggal_mulai || "-" }}</td>
              </tr>
              <tr class="mb-2">
                <td><b>Tanggal Selesai</b></td>
                <td>&nbsp;:&nbsp;</td>
                <td>{{ headerInfo.tanggal_selesai || "-" }}</td>
              </tr>
            </table>
          </div>

          <div class="col-12">
            <hr />
          </div>

          <div class="col-12" v-if="kompetensiState.loading">
            <i class="fas fa-spinner fa-spin"></i> Loading...
          </div>

          <template v-else>
            <div class="col-12 col-lg-6">
              <fieldset
                class="border p-3 rounded"
                style="border-color: #e5e7eb !important"
              >
                <legend class="float-none w-auto px-1 fs-5">
                  Kompetensi ({{ kompetensiState.list.length }})
                </legend>

                <div
                  v-if="kompetensiState.list.length === 0"
                  class="text-center text-muted"
                >
                  Data Tidak Tersedia
                </div>

                <div
                  v-for="(kompetensi, index) in kompetensiState.list"
                  :key="kompetensi.idkompetensi"
                  class="mym-competency-card mb-3"
                >
                  <div class="mym-competency-header">
                    <div class="mym-number">{{ index + 1 }}</div>

                    <div class="mym-competency-content">
                      <div class="mym-competency-title">
                        {{ kompetensi.nama_kompetensi }}
                      </div>

                      <div class="mym-tags">
                        <span
                          class="mym-small-badge mym-soft-badge-primary text-nowrap"
                          :class="
                            kompetensi.status_peserta.tipe_kompetensi == 'CORE'
                              ? 'mym-badge-primary'
                              : 'mym-badge-dark'
                          "
                        >
                          <i class="fas fa-signal"></i>
                          {{ kompetensi.status_peserta.tipe_kompetensi }}
                        </span>
                        <span class="mym-small-badge mym-soft-badge-secondary text-nowrap">
                          Level {{ kompetensi.level_kompetensi_idlevel_kompetensi }}
                        </span>
                        <span
                          class="mym-small-badge mym-soft-badge-info fw-bold text-nowrap"
                          title="Durasi"
                        >
                          <i class="fa fa-stopwatch me-1"></i>
                          {{ kompetensi.timer }} Menit
                        </span>
                        <span
                          class="mym-small-badge mym-soft-badge-danger fw-bold text-nowrap"
                          title="Durasi"
                        >
                          <i class="fa fa-tasks me-1"></i>
                          {{ kompetensi.jumlah_soal }} soal
                        </span>

                        <span
                          v-if="kompetensi.status_peserta.status === 1"
                          class="mym-small-badge mym-badge-light py-1 px-3 text-nowrap"
                        >
                          <i class="fas fa-play"></i> Belum Mengerjakan
                        </span>

                        <span
                          v-else-if="kompetensi.status_peserta.status === 2"
                          class="mym-small-badge mym-badge-warning py-1 px-3 text-nowrap"
                        >
                          <i class="fas fa-hourglass"></i> Sedang Mengerjakan
                        </span>

                        <span
                          v-else-if="
                            kompetensi.status_peserta.status === 3 &&
                            kompetensi.status_peserta.remidi === 0
                          "
                          class="mym-small-badge mym-soft-badge-success text-nowrap"
                        >
                          <i class="fas fa-check-circle"></i> Selesai
                        </span>

                        <span
                          v-else-if="
                            kompetensi.status_peserta.status === 3 &&
                            kompetensi.status_peserta.remidi > 0
                          "
                          class="mym-small-badge mym-badge-danger py-1 px-3 text-nowrap"
                        >
                          <i class="fas fa-redo"></i> Uji Ulang
                        </span>

                        <span
                          v-else-if="kompetensi.status_peserta.status === 4"
                          class="mym-small-badge mym-badge-dark py-1 px-3 text-nowrap"
                        >
                          <i class="fas fa-stop-circle"></i> Dihentikan
                        </span>

                        <span v-else>-</span>
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.mym-section-body {
  padding: 25px 20px;
  background: #ffffff;
}
</style>